import { render, staticRenderFns } from "./NbaLayout.vue?vue&type=template&id=68f7a55a&scoped=true"
import script from "./NbaLayout.vue?vue&type=script&lang=js"
export * from "./NbaLayout.vue?vue&type=script&lang=js"
import style0 from "./NbaLayout.vue?vue&type=style&index=0&id=68f7a55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f7a55a",
  null
  
)

export default component.exports